<template>
    <div>
        <router-view />
    </div>
</template>

<script>
import api from "@/axios/api";
import request from "@/axios/token";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    data() {
        return {};
    },

    created() {
        // if (this.token) {
        //     return
        // } else {
        //     let code = window.location.href.split("&code=")[1];
        //     if (code != undefined) {
        //         request.getToken();
        //     } else {
        //         request.getCode();
        //     }
        // }
    },
    mounted() {},
    methods: {
        ...mapActions({
            saveToken: "saveToken"
        })
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/entrance/hrReport.vue